import platform_routes_ef from './ef/routes';

function getPlatformRoutes(): any {
   return platform_routes_ef;
}

export default getPlatformRoutes();
